var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"rounded-lg open-button",attrs:{"color":"#F39200","width":"40px","height":"40px","min-width":"0"},on:{"click":_vm.openReport}},[_c('v-icon',[_vm._v("mdi-login")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }